import React from 'react'
import styled, { css } from 'styled-components'

interface Props {
  type?: 'list' | 'section'
}

const Divider: React.FC<Props> = ({ type = 'list' }) => {
  return <Wrapper type={type} />
}

const Wrapper = styled.div<Props>`
  width: 100%;

  ${({ type }) =>
    type === 'list' &&
    css`
      height: 1px;
      background-color: #d6d6d6;
    `}

  ${({ type }) =>
    type === 'section' &&
    css`
      height: 10px;
      background-color: #f5f5f5;
    `}
`

export default Divider
